<template>
    <el-dialog class="add_purchase_order" :visible.sync="dialogVisible" :append-to-body="true" :title="dialogTitle"
        width="1280px" @close="handleClose" :modal-append-to-body="true">
        <div class="purchase-order">
            <!-- 基础信息部分 - 只在编辑模式下显示 -->
            <div v-if="isEdit" class="base-info-readonly">
                <div class="order-form">
                    基础信息
                </div>
                <el-row :gutter="20" class="info-row">
                    <el-col :span="6">
                        <div class="info-item">
                            <label>退货单号：</label>
                            <span>{{ baseInfo.returnOrderNo || '无' }}</span>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div class="info-item">
                            <label>退货单创建人：</label>
                            <span>{{ baseInfo.createdByName || '无' }}</span>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div class="info-item">
                            <label>关联采购单号：</label>
                            <span>{{ baseInfo.purchaseOrderNo || '无' }}</span>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div class="info-item">
                            <label>退货单状态：</label>
                            <span>{{ baseInfo.statusLabel || '无' }}</span>
                        </div>
                    </el-col>
                </el-row>
                <el-row :gutter="20" class="info-row">
                    <el-col :span="6">
                        <div class="info-item">
                            <label>采购退货单创建时间：</label>
                            <span>{{ baseInfo.createdTime || '无' }}</span>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div class="info-item">
                            <label>修改时间：</label>
                            <span>{{ baseInfo.updatedTime || '无' }}</span>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div class="info-item">
                            <label>退货数：</label>
                            <span>{{ baseInfo.totalReturnQuantity || '无' }}</span>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div class="info-item">
                            <label>退货金额：</label>
                            <span>{{ baseInfo.totalReturnAmount || '无' }}</span>
                        </div>
                    </el-col>
                </el-row>
            </div>

            <el-form :model="form" :rules="rules" ref="orderForm" label-width="110px" label-position="right">

                <!-- 退货商品列表 -->
                <div class="order-form">
                    退货商品信息
                </div>
                <div class="goods-table-container">
                    <el-form-item>
                        <el-table class="goods-table" :data="form.items" border style="width: 100%; margin-top: 10px;"
                            :summary-method="getSummaries" show-summary>
                            <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
                            <el-table-column label="商品名称" min-width="150" class-name="goods-name-cell">
                                <template slot-scope="scope">
                                    <span class="goods-name-text">{{ scope.row.goodsName || '-' }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="规格" min-width="100">
                                <template slot-scope="scope">
                                    <span class="goods-name-text">{{ scope.row.specification || '-' }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="单位" prop="unitOfMeasure" width="120"></el-table-column>
                            <el-table-column prop="canReturnQuantity" label="可退货数量" min-width="100">
                                <template slot-scope="scope">
                                    <span>{{ scope.row.canReturnQuantity || 0 }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="returnQuantity" label="采购退货数量" min-width="100">
                                <template slot-scope="scope">
                                    <el-input v-if="!isEditable" v-model="scope.row.returnQuantity"
                                        placeholder="请输入" @change="calculateTotalAmount"></el-input>
                                    <span v-else>{{ scope.row.returnQuantity || 0 }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="lineReturnAmount" label="退货金额(元)" min-width="100">
                                <template slot-scope="scope">
                                    <el-input v-if="!isEditable" v-model="scope.row.lineReturnAmount"
                                        placeholder="请输入" @change="calculateTotalAmount"></el-input>
                                    <span v-else>{{ formatCurrency(scope.row.lineReturnAmount) }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="供应商" min-width="150">
                                <template slot-scope="scope">
                                    <span class="goods-name-text">{{ scope.row.supplierName || '-' }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="备注" min-width="150">
                                <template slot-scope="scope">
                                    <el-input v-if="!isEditable" v-model="scope.row.returnReason"
                                        placeholder="请输入"></el-input>
                                    <span v-else>{{ scope.row.returnReason || '-' }}</span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-form-item>
                </div>

                <!-- 采购信息 -->
                <div class="order-form">
                    采购信息
                </div>
                <el-row :gutter="20" style="padding-left: 45px;margin-bottom: 10px;" class="info-row">
                    <el-col :span="6">
                        <div class="info-item">
                            <label>采购员：</label>
                            <span>{{ form.purchaserName || '无' }}</span>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div class="info-item">
                            <label>运费：</label>
                            <span>{{ formatCurrency(form.freightCost) || '无' }}</span>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div class="info-item">
                            <label>优惠金额：</label>
                            <span>{{ formatCurrency(form.discountAmount) || '无' }}</span>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div class="info-item">
                            <label>采购总金额：</label>
                            <span>{{ formatCurrency(form.finalAmount) || '无' }}</span>
                        </div>
                    </el-col>
                </el-row>

                <el-row :gutter="20" style="padding-left: 45px;margin-bottom: 10px;" class="info-row">
                    <el-col :span="6">
                        <div class="info-item">
                            <label>收货地址：</label>
                            <span>{{ form.shippingAddress || '无' }}</span>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div class="info-item">
                            <label>采购单备注：</label>
                            <span>{{ form.remarks || '无' }}</span>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div class="info-item">
                            <label>附件：</label>
                            <div v-if="form.purchaseAttachmentUrl" class="attachment-display">
                                <a :href="form.purchaseAttachmentUrl" target="_blank" class="attachment-link">
                                    <i class="el-icon-document"></i>
                                    {{ form.purchaseAttachmentName || '下载附件' }}
                                </a>
                            </div>
                            <span v-else class="info-text">{{ form.purchaseAttachmentName || '无' }}</span>
                        </div>
                    </el-col>
                </el-row>

                <!-- 退货信息 -->
                <div class="order-form">
                    退货信息
                </div>
                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item label="退货员" prop="returnerName">
                            <el-select ref="returnSelect" :disabled="isEditable" v-model="form.returnerName"
                                placeholder="请选择" clearable filterable @focus="openUserPicker"
                                @visible-change="handleReturnSelectVisible">
                                <el-option v-if="form.returnerId && form.returnerName" :key="form.returnerId"
                                    :label="form.returnerName" :value="form.returnerName">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="运费" prop="returnFreightCost">
                            <el-input :disabled="isEditable" v-model="form.returnFreightCost" 
                                placeholder="请输入" @change="calculateTotalAmount"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="退货总金额" prop="finalReturnAmount">
                            <span class="total-amount-text">
                                {{ formatCurrency(calculatedTotalAmount) }}
                            </span>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item label="退货地址" prop="returnAddress">
                            <el-input :disabled="isEditable" v-model="form.returnAddress" placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="退货单备注" prop="returnRemarks">
                            <el-input :disabled="isEditable" v-model="form.returnRemarks" placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="附件" prop="attachmentUrl">
                            <div v-if="!isEditable">
                                <!-- 上传按钮只在没有附件时显示 -->
                                <el-upload v-if="fileList.length === 0" ref="upload" accept="*" drag action="#"
                                    :multiple="false" :http-request="orderImportLive" :limit="1"
                                    :before-upload="beforeUpload" :file-list="fileList">
                                    <el-button type="primary" plain size="mini">点击上传</el-button>
                                </el-upload>
                                <!-- 文件列表显示 -->
                                <div v-else class="file-list">
                                    <div class="file-item">
                                        <i class="el-icon-document"></i>
                                        <span class="file-name">{{ fileList[0].name }}</span>
                                        <el-button type="text" size="mini" @click="handleRemove">删除</el-button>
                                    </div>
                                </div>
                                <!-- 文件上传说明 -->
                                <div class="upload-tips">
                                    (大小限制在10M以内，支持 .doc, .docx, .xls, .xlsx, .pdf, .jpg, .jpeg, .png 格式文件)
                                </div>
                            </div>
                            <div v-else>
                                <div v-if="form.attachmentUrl" class="attachment-display">
                                    <a :href="form.attachmentUrl" target="_blank" class="attachment-link">
                                        <i class="el-icon-document"></i>
                                        {{ form.attachmentName || '下载附件' }}
                                    </a>
                                </div>
                                <span v-else class="info-text">无附件</span>
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>

            </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button v-if="type === 'add' || (isEdit && baseInfo.status === 0)" size="mini" type="primary"
                @click="submitForm" :loading="submitLoading" :disabled="submitLoading">
                {{ submitLoading ? '生效中...' : '确认生效' }}
            </el-button>
            <el-button v-if="type === 'add' || (isEdit && baseInfo.status === 0)" size="mini" type="primary" @click="saveForm" :loading="saveLoading" :disabled="saveLoading">
                {{ saveLoading ? '保存中...' : '保存' }}
            </el-button>
            <el-button size="mini" @click="dialogVisible = false">取消</el-button>
        </div>
        <org-picker title="选择退货员" :multiple="false" ref="orgPicker" @ok="selectedReturner" />
    </el-dialog>
</template>

<script>
import OrgPicker from "@/components/OrgPicker.vue";

export default {
    name: 'PurchaseReturnDialog',
    components: {
        OrgPicker
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        type: {
            type: String,
            default: 'add'
        },
        formData: {
            type: Object,
            default: () => ({})
        },
        selectedPurchaseOrders: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            submitLoading: false,
            saveLoading: false,
            fileList: [],
            logFile: null,
            baseInfo: {
                returnOrderNo: '',
                statusLabel: '',
                status: null,
                returnerName: '',
                createdTime: '',
                purchaseOrderNo: '',
                updatedTime: '',
                totalReturnQuantity: 0,
                totalReturnAmount: 0,
                createdByName: ''
            },
            rules: {
                returnerName: [{ required: true, message: '请选择退货员', trigger: 'change' }],
            },
            form: {
                id: null,
                purchaseOrderId: '',
                purchaseOrderNo: '',
                supplierName: '',
                applicantName: '',
                returnerId: '',
                returnerName: '',
                finalReturnAmount: 0, // 保留此字段用于提交
                returnFreightCost: 0,
                returnAddress: '',
                returnRemarks: '',
                attachmentUrl: '',
                attachmentName: '',
                // 新增采购附件字段
                purchaseAttachmentName: '',
                purchaseAttachmentUrl: '',
                items: []
            },
        };
    },
    watch: {
        selectedPurchaseOrders: {
            immediate: true,
            handler(newVal) {
                if (newVal && newVal.length > 0 && this.type === 'add') {
                    this.fillFormFromPurchaseOrders(newVal);
                }
            }
        },
        visible(newVal) {
            if (newVal) {
                if (this.type === 'add' && this.selectedPurchaseOrders.length > 0) {
                    // 新增模式下清空基础信息
                    this.resetBaseInfo();
                    this.fillFormFromPurchaseOrders(this.selectedPurchaseOrders);
                    // 计算初始总金额
                    this.$nextTick(() => {
                        this.calculateTotalAmount();
                    });
                } else if (this.type === 'edit' && this.formData.id) {
                    this.resetBaseInfo();
                    this.fetchReturnOrderDetail(this.formData.id);
                }
            }
        },
        // 监听items变化，计算总金额
        'form.items': {
            deep: true,
            handler() {
                this.calculateTotalAmount();
            }
        }
    },
    computed: {
        dialogVisible: {
            get() {
                return this.visible;
            },
            set(value) {
                this.$emit('update:visible', value);
            }
        },
        dialogTitle() {
            const titles = {
                'add': '新增办公物资采购退货单',
                'edit': '查看/编辑办公物资采购退货单'
            };
            return titles[this.type] || '退货单';
        },
        isEditable() {
           // 编辑模式且状态为1（已生效）、2（已作废），或者查看模式
           if (this.isEdit) {
                return this.baseInfo.status === 1 || this.baseInfo.status === 2; // 状态1为已生效
            }
            return false; // 新增模式下不是已生效状态
        },
        isEdit() {
            return this.type === 'edit';
        },
        // 计算退货总金额：表格合计金额 + 运费
        calculatedTotalAmount() {
            // 计算表格中所有退货金额的合计
            const totalItemsAmount = this.form.items.reduce((total, item) => {
                const amount = parseFloat(item.lineReturnAmount) || 0;
                return total + amount;
            }, 0);
            
            // 加上运费
            const freight = parseFloat(this.form.returnFreightCost) || 0;
            const totalAmount = totalItemsAmount + freight;
            
            // 更新form中的finalReturnAmount字段，用于提交
            this.form.finalReturnAmount = totalAmount;
            
            return totalAmount;
        }
    },
    methods: {
        // 计算总金额
        calculateTotalAmount() {
            // 触发计算属性的更新
            // 计算属性会自动更新，这里不需要额外操作
        },
        
        // 重置基础信息
        resetBaseInfo() {
            this.baseInfo = {
                returnOrderNo: '',
                status: null,
                statusLabel: '',
                returnerName: '',
                createdTime: '',
                purchaseOrderNo: '',
                updatedTime: '',
                totalReturnQuantity: 0,
                totalReturnAmount: 0,
                createdByName: ''
            };
        },

        // 阻止退货员下拉框展开
        handleReturnSelectVisible(visible) {
            if (visible && this.$refs.returnSelect) {
                this.$nextTick(() => {
                    // 关闭下拉并移除焦点，避免显示历史选项
                    if (this.$refs.returnSelect.blur) {
                        this.$refs.returnSelect.blur();
                    }
                    this.$refs.returnSelect.visible = false;
                });
            }
        },

        // 获取退货单详情
        fetchReturnOrderDetail(id) {
            this.loading = true;
            this.$api.srmReturnOrderDetail({ id }).then(res => {
                if (res.code === 0) {
                    this.fillFormFromReturnOrderDetail(res.data);
                    console.log(res.data, "退货单详情");
                } else {
                    this.$message.error(res.msg);
                }
            }).catch(error => {
                this.$message.error('获取退货单详情失败，请稍后重试');
            })
        },

        fillFormFromReturnOrderDetail(detailData) {
            console.log('退货单详情数据:', detailData);

            // 设置基础信息
            this.setBaseInfo(detailData);

            const purchaseOrder = detailData.purchaseOrderResponse || {};

            // 解析采购订单的附件信息
            let purchaseAttachmentName = '无';
            let purchaseAttachmentUrl = '';

            if (purchaseOrder.attachmentUrl) {
                try {
                    console.log('原始附件字符串:', purchaseOrder.attachmentUrl);

                    // 方法1: 尝试直接解析为标准JSON
                    if (purchaseOrder.attachmentUrl.startsWith('[{') && purchaseOrder.attachmentUrl.endsWith('}]')) {
                        // 将非标准格式转换为标准JSON
                        let jsonStr = purchaseOrder.attachmentUrl
                            .replace(/=/g, ':') // 将 = 替换为 :
                            .replace(/([a-zA-Z_]+):/g, '"$1":') // 给键名加引号
                            .replace(/:([^,"{}\]}]+)(,|})/g, ':"$1"$2') // 给字符串值加引号
                            .replace(/:(\d+)(,|})/g, ':$1$2'); // 数字值不加引号

                        console.log('转换后的JSON:', jsonStr);

                        const attachmentArray = JSON.parse(jsonStr);
                        if (attachmentArray && attachmentArray.length > 0) {
                            purchaseAttachmentName = attachmentArray[0].name || '下载附件';
                            purchaseAttachmentUrl = attachmentArray[0].url || '';
                        }
                    } else {
                        // 方法2: 如果已经是标准JSON，直接解析
                        const attachmentArray = JSON.parse(purchaseOrder.attachmentUrl);
                        if (attachmentArray && attachmentArray.length > 0) {
                            purchaseAttachmentName = attachmentArray[0].name || '下载附件';
                            purchaseAttachmentUrl = attachmentArray[0].url || '';
                        }
                    }
                } catch (error) {
                    console.error('解析附件信息失败:', error);
                    console.log('原始字符串:', purchaseOrder.attachmentUrl);

                    // 方法3: 使用正则表达式提取关键信息
                    try {
                        const urlMatch = purchaseOrder.attachmentUrl.match(/url=([^,}]+)/);
                        const nameMatch = purchaseOrder.attachmentUrl.match(/name=([^,}]+)/);

                        if (urlMatch && urlMatch[1]) {
                            purchaseAttachmentUrl = urlMatch[1].trim();
                        }
                        if (nameMatch && nameMatch[1]) {
                            purchaseAttachmentName = nameMatch[1].trim();
                        }

                        console.log('正则提取结果:', { purchaseAttachmentName, purchaseAttachmentUrl });
                    } catch (regexError) {
                        console.error('正则提取也失败:', regexError);
                        // 如果所有方法都失败，使用原始字符串
                        purchaseAttachmentName = purchaseOrder.attachmentUrl;
                    }
                }
            }

            this.form = {
                id: detailData.id,
                purchaseOrderId: purchaseOrder.id,
                purchaseOrderNo: detailData.purchaseOrderNo,
                supplierName: purchaseOrder.supplierName || detailData.supplierName,
                applicantName: purchaseOrder.applicantName,
                returnerId: detailData.returnerId,
                returnerName: detailData.returnerName,
                finalReturnAmount: detailData.totalReturnAmount || 0,
                returnFreightCost: detailData.returnFreightCost || 0,
                returnAddress: detailData.returnAddress,
                returnRemarks: detailData.remarks || '',
                attachmentUrl: detailData.attachmentUrl,
                attachmentName: detailData.attachmentName,
                purchaserName: purchaseOrder.purchaserName,
                freightCost: purchaseOrder.freightCost,
                discountAmount: purchaseOrder.discountAmount,
                finalAmount: purchaseOrder.finalAmount,
                shippingAddress: purchaseOrder.shippingAddress,
                remarks: purchaseOrder.remarks,
                // 新增采购附件相关字段
                purchaseAttachmentName: purchaseAttachmentName,
                purchaseAttachmentUrl: purchaseAttachmentUrl,
                items: this.transformReturnItems(detailData.items || [], purchaseOrder.items || [])
            };

            // 设置文件列表
            if (detailData.attachmentUrl) {
                this.fileList = [{
                    name: detailData.attachmentName || '附件',
                    url: detailData.attachmentUrl
                }];
            }
            
            // 计算总金额
            this.$nextTick(() => {
                this.calculateTotalAmount();
            });
        },

        // 设置基础信息
        setBaseInfo(data) {
            this.baseInfo = {
                returnOrderNo: data.returnOrderNo,
                statusLabel: data.statusLabel,
                returnerName: data.returnerName,
                createdTime: data.createdTime,
                purchaseOrderNo: data.purchaseOrderNo,
                updatedTime: data.updatedTime,
                status: data.status,
                totalReturnQuantity: data.totalReturnQuantity,
                totalReturnAmount: data.totalReturnAmount,
                createdByName: data.createdByName
            };
            console.log('baseInfo:', this.baseInfo);
            console.log('基础信息:', data);
        },

        // 转换退货商品数据
        transformReturnItems(returnItems, purchaseItems) {
            const purchaseItemsMap = {};
            purchaseItems.forEach(item => {
                purchaseItemsMap[item.id] = item;
            });

            return returnItems.map(returnItem => {
                const purchaseItem = purchaseItemsMap[returnItem.purchaseOrderItemId] || {};

                return {
                    id: returnItem.id,
                    goodsName: returnItem.goodsName || purchaseItem.goodsName,
                    productImageUrl: purchaseItem.productImageUrl,
                    goodsNo: purchaseItem.goodsNo,
                    purchaseQuantity: purchaseItem.quantity || 0,
                    unitPrice: purchaseItem.unitPrice || 0,
                    returnQuantity: returnItem.returnQuantity || 0,
                    lineReturnAmount: returnItem.lineReturnAmount || 0,
                    returnReason: returnItem.remarks || '',
                    purchaseOrderItemId: returnItem.purchaseOrderItemId,
                    specification: returnItem.specification || purchaseItem.specification,
                    unitOfMeasure: returnItem.unitOfMeasure || purchaseItem.unitOfMeasure,
                    supplierName: purchaseItem.supplierName || '',
                    canReturnQuantity: purchaseItem.canReturnQuantity || 0,
                };
            });
        },

        // 文件上传相关方法
        orderImportLive(fileObj) {
            const formData = new FormData();
            formData.append('file', fileObj.file);
            this.logFile = formData;

            this.uploadFile().then(() => {
                this.$message.success('文件上传成功！');
            }).catch(error => {
                this.$message.error('文件上传失败！');
                console.error('文件上传失败:', error);
            });
        },

        async uploadFile() {
            if (!this.logFile) {
                this.$message.warning('请选择文件');
                return Promise.reject('没有选择文件');
            }

            try {
                const config = {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    },
                    timeout: 120000
                };

                const response = await this.$api.uploadFiles(this.logFile, config);

                if (response.code === 0) {
                    this.form.attachmentUrl = response.data.fileUrl || response.data.url;
                    this.form.attachmentName = response.data.fileName || this.logFile.get('file').name;

                    this.fileList = [{
                        name: this.form.attachmentName,
                        url: this.form.attachmentUrl
                    }];

                    return Promise.resolve();
                } else {
                    this.$message.error(response.msg || '文件上传失败');
                    return Promise.reject(response.msg);
                }
            } catch (error) {
                this.$message.error('文件上传失败，请稍后重试');
                console.error('文件上传失败:', error);
                return Promise.reject(error);
            }
        },

        handleRemove(file, fileList) {
            this.logFile = null;
            this.form.attachmentUrl = '';
            this.form.attachmentName = '';
            this.fileList = [];
        },

        beforeUpload(file) {
            const isLt10M = file.size / 1024 / 1024 < 10;
            const allowedTypes = [
                'application/msword',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                'application/vnd.ms-excel',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'application/pdf',
                'image/jpeg',
                'image/jpg',
                'image/png'
            ];

            if (!allowedTypes.includes(file.type)) {
                this.$message.error('文件格式不支持！请上传文档、表格、PDF或图片文件。');
                return false;
            }

            if (!isLt10M) {
                this.$message.error('文件大小不能超过 10MB!');
                return false;
            }

            return true;
        },

        // 从采购订单数据填充表单（新增时使用）
        fillFormFromPurchaseOrders(purchaseOrders) {
            if (!purchaseOrders || purchaseOrders.length === 0) return;

            const firstOrder = purchaseOrders[0];
            console.log('采购订单数据:', firstOrder);

            // 解析采购订单的附件信息 - 使用相同的解析逻辑
            let purchaseAttachmentName = '无';
            let purchaseAttachmentUrl = '';

            if (firstOrder.attachmentUrl) {
                try {
                    console.log('原始附件字符串:', firstOrder.attachmentUrl);

                    if (firstOrder.attachmentUrl.startsWith('[{') && firstOrder.attachmentUrl.endsWith('}]')) {
                        let jsonStr = firstOrder.attachmentUrl
                            .replace(/=/g, ':')
                            .replace(/([a-zA-Z_]+):/g, '"$1":')
                            .replace(/:([^,"{}\]}]+)(,|})/g, ':"$1"$2')
                            .replace(/:(\d+)(,|})/g, ':$1$2');

                        console.log('转换后的JSON:', jsonStr);

                        const attachmentArray = JSON.parse(jsonStr);
                        if (attachmentArray && attachmentArray.length > 0) {
                            purchaseAttachmentName = attachmentArray[0].name || '下载附件';
                            purchaseAttachmentUrl = attachmentArray[0].url || '';
                        }
                    } else {
                        const attachmentArray = JSON.parse(firstOrder.attachmentUrl);
                        if (attachmentArray && attachmentArray.length > 0) {
                            purchaseAttachmentName = attachmentArray[0].name || '下载附件';
                            purchaseAttachmentUrl = attachmentArray[0].url || '';
                        }
                    }
                } catch (error) {
                    console.error('解析附件信息失败:', error);

                    try {
                        const urlMatch = firstOrder.attachmentUrl.match(/url=([^,}]+)/);
                        const nameMatch = firstOrder.attachmentUrl.match(/name=([^,}]+)/);

                        if (urlMatch && urlMatch[1]) {
                            purchaseAttachmentUrl = urlMatch[1].trim();
                        }
                        if (nameMatch && nameMatch[1]) {
                            purchaseAttachmentName = nameMatch[1].trim();
                        }
                    } catch (regexError) {
                        console.error('正则提取也失败:', regexError);
                        purchaseAttachmentName = firstOrder.attachmentUrl;
                    }
                }
            }

            this.form = {
                // 重置退货相关字段为默认值
                id: null,
                purchaseOrderId: firstOrder.id,
                purchaseOrderNo: firstOrder.purchaseOrderNo,
                supplierName: firstOrder.supplierName,
                applicantName: firstOrder.applicantName,
                returnerId: '',
                returnerName: '',
                finalReturnAmount: 0, // 退货总金额默认为0
                returnFreightCost: 0, // 退货运费默认为0，而不是继承采购运费
                returnAddress: '',
                returnRemarks: '',
                attachmentUrl: '',
                attachmentName: '',

                // 采购信息（只读）
                purchaserName: firstOrder.purchaserName,
                freightCost: firstOrder.freightCost,
                discountAmount: firstOrder.discountAmount,
                finalAmount: firstOrder.finalAmount,
                shippingAddress: firstOrder.shippingAddress,
                remarks: firstOrder.remarks,

                // 采购附件信息
                purchaseAttachmentName: purchaseAttachmentName,
                purchaseAttachmentUrl: purchaseAttachmentUrl,

                // 退货商品列表
                items: this.transformPurchaseItemsToReturnItems(firstOrder.items || [])
            };
        },

        // 转换采购商品为退货商品
        transformPurchaseItemsToReturnItems(purchaseItems) {
            console.log('退货信息:', purchaseItems);

            return purchaseItems.map(item => ({
                ...item,
                id: null,
                purchaseQuantity: item.quantity || 0,
                returnQuantity: 0,
                lineReturnAmount: 0,
                returnReason: '',
                purchaseOrderItemId: item.id
            }));
        },

        // 选择退货员
        openUserPicker() {
            const selectedIds = this.form.returnerId ? [this.form.returnerId] : [];
            this.$refs.orgPicker.show(selectedIds, 'user');
        },

        selectedReturner(users) {
            if (users && users.length > 0) {
                const selectedUser = users[0];
                this.form.returnerId = Number(selectedUser.id);
                this.form.returnerName = selectedUser.serial + selectedUser.name;
            }
        },

        // 提交退货单
        async submitForm() {
            await this.saveOrSubmit(true);
        },

        // 保存表单（保存草稿）
        async saveForm() {
            await this.saveOrSubmit(false);
        },

        // 统一的保存/提交方法
        async saveOrSubmit(effectFlag) {
            this.$refs.orderForm.validate(async (valid) => {
                if (!valid) {
                    this.$message.error('请填写必填项');
                    return false;
                }

                // 修改：检查至少有一条数据的退货数量有效
                const hasValidReturnQuantity = this.form.items.some(item => {
                    const returnQuantity = parseFloat(item.returnQuantity) || 0;
                    const canReturnQuantity = parseFloat(item.canReturnQuantity) || 0;
                    return returnQuantity > 0 && returnQuantity <= canReturnQuantity;
                });

                if (!hasValidReturnQuantity) {
                    this.$message.error('请至少填写一条有效的退货数量（大于0且不超过可退货数量）');
                    return false;
                }

                // 修改：检查有效数据的退货原因
                const validItems = this.form.items.filter(item => {
                    const returnQuantity = parseFloat(item.returnQuantity) || 0;
                    const canReturnQuantity = parseFloat(item.canReturnQuantity) || 0;
                    return returnQuantity > 0 && returnQuantity <= canReturnQuantity;
                });

                if (this.form.items.length === 0) {
                    this.$message.error('请至少添加一个退货商品');
                    return false;
                }

                try {
                    if (effectFlag) {
                        this.submitLoading = true;
                    } else {
                        this.saveLoading = true;
                    }

                    if (this.logFile) {
                        await this.uploadFile();
                    }

                    const submitData = this.getSubmitData(effectFlag);

                    let response;
                    if (this.type === 'add') {
                        if (effectFlag) {
                            // 先调用新增接口
                            response = await this.$api.srmReturnOrderEffect(submitData);
                        } else {
                            response = await this.$api.srmReturnOrderAdd(submitData);
                        }
                    } else {
                        if (effectFlag) {
                            response = await this.$api.srmReturnOrderEffect(submitData);
                        } else {
                            response = await this.$api.srmReturnOrderEdit(submitData);
                        }
                    }

                    if (response.code === 0) {
                        const successMessage = effectFlag
                            ? '退货单生效成功'
                            : (this.type === 'add' ? '新增退货单成功' : '保存退货单成功');

                        this.$message.success(successMessage);
                        this.dialogVisible = false;
                        this.$emit('submit', submitData);
                        this.$emit('success');
                    } else {
                        this.$message.error(response.msg || '操作失败');
                    }
                } catch (error) {
                    console.error('操作失败:', error);
                    this.$message.error('操作失败，请稍后重试');
                } finally {
                    this.submitLoading = false;
                    this.saveLoading = false;
                }
            });
        },

        // 获取提交数据
        getSubmitData(effectFlag) {
            const baseData = {
                id: this.form.id,
                purchaseOrderId: this.form.purchaseOrderId,
                returnerId: this.form.returnerId,
                returnFreightCost: parseFloat(this.form.returnFreightCost) || 0,
                finalReturnAmount: parseFloat(this.form.finalReturnAmount) || 0,
                attachmentUrl: this.form.attachmentUrl,
                returnAddress: this.form.returnAddress,
                remarks: this.form.returnRemarks,
                effectFlag: effectFlag,
                items: this.form.items.map(item => ({
                    id: item.id,
                    purchaseOrderItemId: item.purchaseOrderItemId,
                    returnQuantity: parseInt(item.returnQuantity) || 0,
                    lineReturnAmount: parseFloat(item.lineReturnAmount) || 0,
                    remarks: item.returnReason
                })).filter(item => item.returnQuantity > 0)
            };
            console.log('提交数据:', baseData);
            return baseData;
        },

        handleClose() {
            this.$refs.orderForm.clearValidate();
            // 重置基础信息
            this.resetBaseInfo();
            this.$emit('closed');
        },

        formatCurrency(value) {
            if (value === null || value === undefined) return '¥0.00';
            return '¥' + Number(value).toFixed(2);
        },

        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计';
                    return;
                }

                if (column.property === 'returnQuantity' || column.property === 'lineReturnAmount') {
                    const values = data.map(item => Number(item[column.property]));
                    if (!values.every(value => isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        }, 0);
                        if (column.property === 'lineReturnAmount') {
                            sums[index] = '¥' + sums[index].toFixed(2);
                        }
                    } else {
                        sums[index] = 'N/A';
                    }
                } else {
                    sums[index] = '';
                }
            });

            return sums;
        }
    }
};
</script>

<style scoped lang="scss">
.add_purchase_order {
    /deep/ {
        .el-dialog__title {
            font-weight: 400;
            font-size: 16px;
            color: #333333;
        }

        .el-dialog__body {
            font-size: 14px;
        }
    }
}

.purchase-order {
    margin-top: 20px;

    /deep/.el-form-item__label {
        width: 100px;
        height: 30px;
        line-height: 30px;
    }

    /deep/ .el-table img {
        vertical-align: middle;
    }

    /deep/.el-input,
    /deep/.el-input__inner {
        height: 30px;
        line-height: 30px;
    }

    /deep/ .el-select__caret {
        margin-top: 6px;
    }

    /deep/.el-form-item {
        margin-bottom: 15px;
        font-weight: 400;
        font-size: 12px;
        color: #606266;
    }

    /deep/ .el-form-item__content {
        margin-left: 10px;
        line-height: 16px;
    }

    /deep/ {
        .el-textarea {
            width: 100%;
        }
    }

    /deep/.el-select {
        width: 100%;

        /deep/.el-input__icon {
            height: 30px;
            line-height: 30px;
        }
    }

    // 商品名称单元格样式 - 单行显示，超出省略号
    /deep/ .goods-table {
        .goods-name-cell {
            .cell {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                display: block;
                max-width: 100%;
            }
        }

        // 商品名称文本样式
        .goods-name-text {
            display: inline-block;
            max-width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            vertical-align: middle;
        }
    }

    /* 上传组件样式 */
    /deep/ .el-upload {
        width: 100px;
    }

    /deep/ .el-upload-dragger {
        width: 100px;
        height: 33px;
        border: none;
    }

    /deep/ .el-upload__tip {
        margin-top: 0px;
        color: #909399;
        font-size: 12px;
    }
    
    // 退货总金额文本样式
    .total-amount-text {
        display: inline-block;
        height: 30px;
        line-height: 30px;
    }
}

.order-form {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: bold;
    font-size: 16px;
    color: #333333;
    margin-left: 27px;
    margin-bottom: 10px;
}

.goods-table-container {
    margin-left: -70px;
    width: calc(100% + 70px);

    /deep/ .el-table {
        .el-table__header-wrapper,
        .el-table__body-wrapper {
            margin-left: 0;
        }

        .el-table__cell {
            padding: 8px 0;
        }
    }
}

// 基础信息只读样式 - 修改为左对齐
.base-info-readonly {
    margin-bottom: 20px;
    border-radius: 4px;

    .info-row {
        margin-bottom: 10px;
        padding-left: 10px;

        &:last-child {
            margin-bottom: 0;
        }
    }

    .info-item {
        display: flex;
        align-items: center;
        min-height: 32px;
        line-height: 32px;
        margin-left: 32px;

        label {
            color: #606266;
            min-width: auto;
            text-align: left;
            white-space: nowrap;
            flex-shrink: 0;
        }

        span {
            color: #333;
            flex: 1;
            text-align: left;
            white-space: nowrap;
        }
    }
}

// 信息文本样式
.info-text {
    color: #333;
    line-height: 30px;
}

// 文件列表样式
.file-list {
    .file-item {
        display: flex;
        align-items: center;

        .file-name {
            margin-left: 8px;
            flex: 1;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }
}

// 上传提示样式
.upload-tips {
    font-size: 12px;
    color: #909399;
    margin-top: 5px;
}

.attachment-display {
    .attachment-link {
        color: #409EFF;
        text-decoration: none;

        &:hover {
            text-decoration: underline;
        }

        i {
            margin-right: 5px;
        }
    }
}

.dialog-footer {
    text-align: right;
    padding: 10px 0;
}
</style>